import { Validator } from '@vista-digital/validator';
import { defaultSeatAppearanceConfig, seatAppearanceConfigValidator } from './seat-appearance';
import { seatAppearanceStatesConfigValidator } from './seat-appearance-states';
export const defaultSeatTypeAppearanceConfig = {
    default: defaultSeatAppearanceConfig,
    normal: {
        default: {
            iconName: 'normal-seat'
        },
        selected: {
            iconName: 'normal-seat-selected',
            showLabels: false
        },
        house: {
            iconName: 'normal-seat-house',
            showLabels: false
        }
    },
    wheelchair: {
        default: {
            iconName: 'wheelchair-seat',
            showLabels: false
        },
        selected: {
            iconName: 'wheelchair-seat-selected',
            showLabels: false
        },
        house: {
            iconName: 'wheelchair-seat-house',
            showLabels: false
        }
    },
    companion: {
        default: {
            iconName: 'companion-seat',
            showLabels: false
        },
        selected: {
            iconName: 'companion-seat-selected',
            showLabels: false
        },
        house: {
            iconName: 'companion-seat-house',
            showLabels: false
        }
    },
    sofaLeft: {
        default: {
            iconName: 'sofa-left-seat',
            labelOffsetX: 3,
            labelOffsetY: -3
        },
        selected: {
            iconName: 'sofa-left-seat-selected',
            showLabels: false
        },
        house: {
            iconName: 'sofa-left-seat-house',
            showLabels: false
        }
    },
    sofaMiddle: {
        default: {
            iconName: 'sofa-middle-seat',
            labelOffsetX: 0,
            labelOffsetY: -3
        },
        selected: {
            iconName: 'sofa-middle-seat-selected',
            showLabels: false
        },
        house: {
            iconName: 'sofa-middle-seat-house',
            showLabels: false
        }
    },
    sofaRight: {
        default: {
            iconName: 'sofa-right-seat',
            labelOffsetX: -3,
            labelOffsetY: -3
        },
        selected: {
            iconName: 'sofa-right-seat-selected',
            showLabels: false
        },
        house: {
            iconName: 'sofa-right-seat-house',
            showLabels: false
        }
    },
    friend: {
        default: {
            iconName: 'friend-seat',
            showLabels: false
        }
    }
};
export const seatTypeAppearanceConfigValidator = Validator.object({
    default: seatAppearanceConfigValidator,
    normal: Validator.optional(seatAppearanceStatesConfigValidator),
    wheelchair: Validator.optional(seatAppearanceStatesConfigValidator),
    companion: Validator.optional(seatAppearanceStatesConfigValidator),
    sofaLeft: Validator.optional(seatAppearanceStatesConfigValidator),
    sofaMiddle: Validator.optional(seatAppearanceStatesConfigValidator),
    sofaRight: Validator.optional(seatAppearanceStatesConfigValidator),
    friend: Validator.optional(seatAppearanceStatesConfigValidator)
});
//# sourceMappingURL=seat-type-appearance.js.map